import React = require('react');
import Warning from '../../../../components/Warning';
import l10n = require('diy/util/l10n');
import {isModuleLimitReached} from '../../index';

export interface MessagesProps {
    showAddGroup: boolean;
    showLimit?: boolean;
}
interface MessagesState { }

export class Messages extends React.Component<MessagesProps, MessagesProps> {

    render() {
        switch (true) {
            case this.props.showLimit || isModuleLimitReached():
                return (
                    <Warning
                        isError={true}
                        text={l10n.getString('section.actionBar.warnings.maxAmountModulesPerPage')}
                        />
                );
            case this.props.showAddGroup:
                return (
                    <Warning text={l10n.getString('section.actionBar.warnings.addGroup')} />
                );
            default:
                return null;
        }

    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/common/Messages.tsx
 **/